import { ProductDTO } from 'src/models/pim';
import { DictionaryTitlesCode } from 'src/models/pim/dictionaries';
import { ProductAttributeCode } from 'src/models/pim/attributes';
import { ProductPageLegalMentions } from 'src/modules/products/components/ProductPage/ProductPageLegalMentions';
import { ProductPageSctSection } from 'src/modules/products/components/ProductPage/ProductPageSctSection';
import { ProductPageBenefitsSection } from 'src/modules/products/components/ProductPage/ProductPageBenefitsSection';
import { ProductPageResultsSection } from 'src/modules/products/components/ProductPage/ProductPageResultsSection';
import { ProductPageSEO } from 'src/modules/products/components/ProductPage/ProductPageSEO';
import { ProductPageInvolvedProducts } from 'src/modules/products/components/ProductPage/ProductPageInvolvedProducts';
import { StickyMenuProvider } from 'src/components/common/StickyMenu/StickyMenuContext';
import { ProductPageProtocolsBannerSection } from 'src/modules/products/components/ProductPage/ProductPageProtocolsBannerSection';
import { ProductPageProtocolsSessions } from 'src/modules/products/components/ProductPage/ProductPageProtocolsSessions';

export const ProductPageProtocolsTemplate = (product: ProductDTO) => {
  return (
    <>
      <ProductPageSEO {...product} />

      <StickyMenuProvider key={product.code}>
        <ProductPageProtocolsBannerSection {...product} />

        <ProductPageBenefitsSection
          product={product}
          textCode={ProductAttributeCode.TreatmentEssentialsText}
          titleCode={ProductAttributeCode.ProtocolDescriptionTitle}
          descriptionCode={ProductAttributeCode.ProtocolDescriptionText}
        />

        <ProductPageResultsSection
          product={product}
          textCode={ProductAttributeCode.KeyBenefitsText}
          titleCode={ProductAttributeCode.KeyBenefitsTitle}
          dictionaryTitleCode={DictionaryTitlesCode.KeyBenefits}
        />

        <ProductPageInvolvedProducts {...product} />

        <ProductPageProtocolsSessions {...product} />

        <ProductPageSctSection {...product} />

        <ProductPageLegalMentions {...product} />
      </StickyMenuProvider>
    </>
  );
};
